import React from "react";
import { DocumentAccessContentType } from "./models/DocumentAccessContentType";

interface DocumentAccessHeaderAreaProps {
  contentType: DocumentAccessContentType;
  headerAreaText: string;
  logInReturnUrl: string;
}

export const DocumentAccessHeaderArea = ({
  contentType,
  headerAreaText,
  logInReturnUrl,
}: DocumentAccessHeaderAreaProps) => {
  return (
    <div className="document-access-modal__top-side">
      <div className="document-access-modal__top-content">
        <div className="document-access-modal__header">
          <div dangerouslySetInnerHTML={{ __html: headerAreaText }} />
        </div>
      </div>
    </div>
  );
};
